import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer";
import { v4 as uuidv4 } from "uuid";
import { PMOTeamMemberModel } from "./pmoTeamMember";
let PMOTeamDetailedViewModel = /** @class */ (() => {
    class PMOTeamDetailedViewModel {
        constructor() {
            this.id = uuidv4();
            this.name = "";
            this.teamMembers = [];
            this.apexProjects = [];
            this.isActive = false;
            this.deactivatedOn = null;
            this.deactivatedReason = null;
        }
    }
    __decorate([
        Type(() => PMOTeamMemberModel),
        __metadata("design:type", Array)
    ], PMOTeamDetailedViewModel.prototype, "teamMembers", void 0);
    return PMOTeamDetailedViewModel;
})();
export { PMOTeamDetailedViewModel };
export default class PMOTeamDetailedView extends PMOTeamDetailedViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
